import { toast } from "react-toastify";

import apiClient from "../../apis/api-client";
import { getFriendlyErrorMessage } from "../../util/error-message-mapper";
import { BaseApplicationService } from "../../domain/base/base-application-service";
import { Paging, Place } from "../../domain/proc-management";
import { reportProcManagementRelatedError } from "../../domain/proc-management/util/error";

export type ContextProps = {
  places: Place[];
  paging: Paging;
  fetchPlacesByOrgId: (organizationId: string, page?: number) => void;
};

export class BaseProcManagementPlacesListService<
  P extends Record<string, any>,
> extends BaseApplicationService<P & ContextProps> {
  constructor(rest: P & Partial<ContextProps>) {
    super();
    this.state = {
      places: [],
      paging: { current: 1, last: 1 },
      fetchPlacesByOrgId: this.fetchPlacesByOrgId.bind(this),
      ...rest,
    };
  }

  async fetchPlacesByOrgId(organizationId: string, page?: number) {
    try {
      const { data } = await apiClient.procManagement.listPlaces({
        organizationId,
        page,
      });
      this.setState((prev) => {
        return { ...prev, places: data.items, paging: data.paging };
      });
    } catch (error) {
      reportProcManagementRelatedError(error);
      const friendlyMessage = getFriendlyErrorMessage(error);
      toast.error(`場所データの取得に失敗しました: ${friendlyMessage}`);
    }
  }
}
